var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-card", {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("div", {
    staticClass: "infoBox"
  }, [_c("a-avatar", {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      size: 64,
      icon: "user"
    }
  }), _c("div", {
    staticClass: "info"
  }, [_c("div", [_vm.infoObj.jobNo ? _c("span", [_vm._v(_vm._s(_vm.infoObj.jobNo || "1") + "/")]) : _vm._e(), _c("span", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.infoObj.name || "张三"))])]), _c("div", {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("手机号")) + ":" + _vm._s(_vm.infoObj.mobile || "157****5648")), _c("span", {
    staticStyle: {
      "margin-left": "50px"
    }
  }, [_vm._v(_vm._s(_vm.$t("入职日期")) + ":" + _vm._s(_vm.infoObj.entryAt || "2022-3-4"))])])])], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };